import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import { BannersActions } from '../_actions/banners.actions';
import { BannersService } from '../../_services/banners.service';

@Injectable()
export class BannersEffects {
  loadActiveBanners$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BannersActions.loadActiveBanners),
      exhaustMap(() =>
        this.bannersService.findAll().pipe(
          map((response) =>
            BannersActions.loadActiveBannersSuccess({ banners: response.data })
          ),
          catchError((error) =>
            of(BannersActions.loadActiveBannersFailure({ error }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private bannersService: BannersService
  ) {}
}
